var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSamoa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1266)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.0003 20.0001C40.0003 31.0457 31.0459 40.0001 20.0003 40.0001C8.95464 40.0001 0.000259399 31.0457 0.000259399 20.0001C6.86979 13.1305 12.6959 7.30444 20.0003 6.10352e-05C31.0459 6.10352e-05 40.0003 8.95444 40.0003 20.0001Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0003 20.0001C20.0003 8.95444 20.0003 7.65225 20.0003 6.10352e-05C8.95464 6.10352e-05 0.000259399 8.95444 0.000259399 20.0001H20.0003Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0199 13.0435L16.3437 14.04H17.3914L16.5437 14.6557L16.8676 15.6522L16.0199 15.0363L15.1723 15.6522L15.4961 14.6557L14.6484 14.04H15.6961L16.0199 13.0435Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7576 5.21741L11.2973 6.87827H13.0435L11.6307 7.90444L12.1705 9.56522L10.7576 8.53873L9.34491 9.56522L9.8846 7.90444L8.47186 6.87827H10.218L10.7576 5.21741Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9751 6.95642L16.5147 8.61736H18.2609L16.8481 9.64353L17.3877 11.3043L15.9751 10.2778L14.5623 11.3043L15.102 9.64353L13.6893 8.61736H15.4354L15.9751 6.95642Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.851 13.913L12.3907 15.5738H14.1368L12.7241 16.6L13.2637 18.2608L11.851 17.2344L10.4383 18.2608L10.978 16.6L9.56523 15.5738H11.3114L11.851 13.913Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27936 9.56525L7.81904 11.2261H9.56521L8.1524 12.2523L8.69209 13.9131L7.27936 12.8867L5.8667 13.9131L6.40631 12.2523L4.99365 11.2261H6.73975L7.27936 9.56525Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1266"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSamoa);
export default __webpack_public_path__ + "static/media/samoa.a8ad1f1b926f4bf4b1bbd5ed5dae6d66.svg";
export { ForwardRef as ReactComponent };